import { render, staticRenderFns } from "./fangyihome.vue?vue&type=template&id=c86c9cea&scoped=true&"
import script from "./fangyihome.vue?vue&type=script&lang=js&"
export * from "./fangyihome.vue?vue&type=script&lang=js&"
import style0 from "./fangyihome.vue?vue&type=style&index=0&id=c86c9cea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86c9cea",
  null
  
)

export default component.exports